import React from 'react';

interface Props {
  width?: number;
  height?: number;
  className?: string;
}

export function ArrowRightCircle(props: Props) {
  const { width = 24, height = 24, className = '' } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g filter="url(#filter0_b_6157_199929)">
        <rect width={24} height={24} rx={12} fill="white" fillOpacity="1" />
        <path
          d="M11 8L15 12L11 16"
          stroke="white"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_6157_199929"
          x={-2}
          y={-2}
          width={28}
          height={28}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation={1} />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_6157_199929"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_6157_199929"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
